export default __webpack_public_path__ + "static/annisa-24cc4680dfec054ff8896d90b2be6b84.png";